import { toJapaneseNumber } from './toJapaneseNumber';

export function formatJapaneseDate(dateString) {
    const date = new Date(dateString);

    // Format using Japanese locale with Japanese numerals (traditional)
    const formatter = new Intl.DateTimeFormat('ja-JP-u-nu-jpan', { year: 'numeric', month: 'long', day: 'numeric' });

    const formatted = formatter.format(date);

    // split the formatted string into parts based on presence of arabic numerals, and then conver the arabic numerals to kanji using the toJapaneseNumber function
    const parts = formatted.split(/(\d+)/).map((part) => {
        const number = parseInt(part, 10);
        return isNaN(number) ? part : toJapaneseNumber(number, 'Kanji');
    });
    // Join the parts back together
    const formattedDate = parts.join('');
    return formattedDate;
}
